/**
 *
 * Asynchronously loads the component for GuestWelcome
 *
 */

import { lazyLoad } from 'utils/loadable';

export const GuestWelcome = lazyLoad(
  () => import('./index'),
  module => module.GuestWelcome,
);
